"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("../store"));
const userTyping_1 = require("../actions/chats/userTyping");
const USER_TYPING_EVENT_MIN_INTERVAL_MS = 1000; // 1 second
const MARK_TYPING_STOPPED_INTERVAL_MS = 5000; // 5 seconds
class CurrentUserTypingHandler {
    constructor() {
        this.chatId = null;
        this.lastUpdated = null;
        this.currentUserStoppedTypingTimeoutId = null;
        this.markTyping = (chatId) => {
            const now = new Date();
            if (this.chatId) {
                if (chatId !== this.chatId) {
                    this.markTypingStopped(this.chatId);
                }
                else if (this.lastUpdated && now.getTime() - this.lastUpdated.getTime() < USER_TYPING_EVENT_MIN_INTERVAL_MS) {
                    return;
                }
            }
            this.chatId = chatId;
            this.lastUpdated = now;
            const event = {
                type: userTyping_1.CURRENT_USER_TYPING,
                payload: chatId
            };
            store_1.default.dispatch(event);
            if (this.currentUserStoppedTypingTimeoutId) {
                clearTimeout(this.currentUserStoppedTypingTimeoutId);
            }
            this.currentUserStoppedTypingTimeoutId = setTimeout(() => this.markTypingStopped(chatId), MARK_TYPING_STOPPED_INTERVAL_MS);
        };
        this.markTypingStopped = (chatId) => {
            if (this.chatId !== chatId) {
                return;
            }
            const event = {
                type: userTyping_1.CURRENT_USER_STOPPED_TYPING,
                payload: chatId
            };
            store_1.default.dispatch(event);
            this.chatId = null;
            this.lastUpdated = null;
            if (this.currentUserStoppedTypingTimeoutId) {
                clearTimeout(this.currentUserStoppedTypingTimeoutId);
                this.currentUserStoppedTypingTimeoutId = null;
            }
        };
    }
}
const handler = new CurrentUserTypingHandler();
exports.default = handler;
